import { DividerProps, Divider as MuiDivider, styled } from '@mui/material';

type Props = DividerProps & {
  dark?: boolean;
};

type StyleProps = {
  dark?: boolean;
};

const StyledDivider = styled(MuiDivider, {
  shouldForwardProp: (props) => props !== 'dark',
})<StyleProps>(({ theme, dark = false }) => ({
  borderColor: dark ? theme.palette.darkBlue.o25 : theme.palette.common.white,
}));

const Divider: React.FC<Props> = ({ dark = false, ...props }) => {
  return <StyledDivider dark={dark} {...props} />;
};

export default Divider;
